import { render, staticRenderFns } from "./m_summarizedspoken.vue?vue&type=template&id=61a650d2&scoped=true&"
import script from "./m_summarizedspoken.vue?vue&type=script&lang=js&"
export * from "./m_summarizedspoken.vue?vue&type=script&lang=js&"
import style0 from "./m_summarizedspoken.vue?vue&type=style&index=0&id=61a650d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a650d2",
  null
  
)

export default component.exports